module.exports = __webpack_public_path__ + "static/media/bunu.3f2c6256.ogg";